module.exports = __webpack_public_path__ + "static/img/brixby.d356760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/brixby.jpg
// module id = DRx7
// module chunks = 1